import Service from '@ember/service';
import ApplicationInstance from '@ember/application/instance';
import { tracked } from '@glimmer/tracking';

interface IAppConfig {
  apiTarget?: string;
  baseIDPHost?: string;
  baseServiceHost?: string;
  defaultRoute?: string;
  deployGeo?: string;
  cloudIDP?: {
    domain?: string;
    clientId?: string;
  };
}

interface IConfig {
  APP?: IAppConfig;
  DEPLOY_TARGETS?: string[];
  environment?: string;
}

export default class ConfigService extends Service {
  @tracked
  _app: IAppConfig | undefined;
  config: IConfig | undefined;
  constructor(instance: ApplicationInstance) {
    super(instance);
    this.config = instance?.resolveRegistration('config:environment') as
      | IConfig
      | undefined;
    this._app = this.config?.APP;
  }

  get app() {
    return this._app;
  }

  set app(app: IAppConfig | undefined) {
    this._app = app;
  }

  get environment() {
    return this.config?.environment;
  }

  get deployTargets() {
    return this.config?.DEPLOY_TARGETS;
  }

  get authenticatorType() {
    return 'cloud-idp';
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    config: ConfigService;
  }
}
